<template>
  <div class="hamburger-cont" @click="toggleClick">
    <svg-icon  icon-class='right'   class="hamburger" :class="{'is-active':isActive}"></svg-icon>
    <!-- <svg t="1492500959545" style="" version="1.1" width="64" height="64"> -->
    <!-- </svg> -->
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}
</script>

<style scoped>
.hamburger-cont{
  background: url("~@/assets/hamburger.png") no-repeat top center;
  left: 105px;
  z-index: 999;
  height: 34px;
  width: 12px;
  top: 50%;
  position: absolute;
  background-size: contain;
}
.hamburger {
	display: inline-block;
	cursor: pointer;
  margin-top: 7px;
  width: 100% !important;
	transform: rotate(0deg);
	transition: .38s;
  transform-origin: 50% 50%;
  color:#fff;
}
.hamburger.is-active {
	transform: rotate(180deg);
}
</style>
